import { transactionTypes } from '../../../config';
import { resources } from '../resources';
import colorCodes from 'style/color-export.module.scss';

const {
  EXCLUDED_FEATURES,
  ENABLE_SUBSCRIPTION_MODULE,
  BOOK_TRAINING_LINK,
  TRAINING_VIDEOS_LINK,
  FUDR_CDN_BASE_PATH,
  SUBSCRIPTION_REQUEST_RAISE_LIMIT_DAYS,
  ADDITIONAL_DISCOUNT_CODE,
} = '_env' in window && window._env;

export const offerStepperSteps = ['Basic Info', 'Applicable on', 'Guests', 'Duration', 'Preview'];

export const customLinkKeyType = {
  custom: 'cu',
  subDomain: 'sd',
};

export const offerGuests = {
  page: 1,
  defaultPageSize: 20,
  defaultSortType: 'name',
};

export const upsell = {
  page: 1,
  pageSize: 20,
  toastMessageTime: 3000,
  sort: 'menuItem.name',
  stopUpsellText: 'STOP', //text will be use to stop upsell
};

export const cashCard = {
  list: {
    page: 1,
    pageSize: 20,
    sort: 'balance',
  },
  details: {
    page: 1,
    pageSize: 20,
    sort: 'initiateDate',
  },
  usage: {
    page: 1,
    pageSize: 20,
    sort: 'initiateDate',
  },
  stopCashCardText: 'STOP', //text wiil be use to stop cash card
  guestCashCardFilterTypes: {
    category: 'cat',
    status: 'status',
    type: 'type',
    date: 'date',
    amount: 'amount',
    restaurantIds: 'resIds',
  },
  issuedCashCardFilterTypes: {
    lastUsed: 'lastUsed',
    issuedOn: 'issuedOn',
    spend: 'spend',
    balance: 'balance',
    recharge: 'recharge',
    status: 'status',
  },
};

const premiumFeaturesList = ['PWA', 'UPSELL', 'CASHCARD'];

const excludedFeatures =
  EXCLUDED_FEATURES === 'null' || EXCLUDED_FEATURES === undefined // If EXCLUDED_FEATURES env var is set to 'null' or not set at all
    ? []
    : EXCLUDED_FEATURES.split(',');

export const premiumFeatureFlags = {};

premiumFeaturesList.forEach(
  (feature) =>
    (premiumFeatureFlags[feature] = excludedFeatures.indexOf(feature) === -1 ? true : false),
);

export const browserPermissionBannerConfig = {
  toatMessageTime: 3000,
};

export const cashCardConfig = {
  toastMessageTime: 3000,
  defaultMinAmount: 100,
  minAmountLowerLimit: 1,
  minAmountMaxLimit: 99999,
  cardNameCharMaxLimit: 50,
  cardNameCharMinLimit: 0,
  noCashCardFound: 'NO_CC_FOUND',
  guestNotFound: 'NOT_FOUND',
  mode: {
    addNewGuest: 'addNewGuest',
    addNewGuestCashCard: 'addNewGuestCashCard',
    rechargeGuestCashCard: 'rechargeGuestCashCard',
    guestNotFound: 'guestNotFound',
  },
  phoneNumberMaxLength: 10,
  rechargeMinAmount: 1,
  rechargeMaxAmount: 20000,
};

export const outletApp = {
  appNameMaxLength: 40,
  pwaAppIconAspectRatio: 1,
  acceptableImageTypes: ['image/jpeg', 'image/png'],
  minDimension: 512,
  appIconFileType: 'png',
  os: { android: 'android', ios: 'ios' },
  imageMagickTempImageName: 'inputImage.png',
  resizeToAndroidIconSizeCommand: [
    'convert',
    'inputImage.png',
    '-resize',
    '512x512',
    '-background',
    'white',
    '-compose',
    'Copy',
    '-gravity',
    'center',
    '-extent',
    '512x512',
    'androidIcon.png',
  ],
  resizeToIOSIconSizeCommand: [
    'convert',
    'inputImage.png',
    '-resize',
    '192x192',
    '-background',
    'white',
    '-compose',
    'Copy',
    '-gravity',
    'center',
    '-extent',
    '192x192',
    'iosIcon.png',
  ],
};

export const featuresArr = ['upsell', 'pwa', 'cashcard'];

export const featuresStatus = {
  active: 'Active',
  paused: 'Paused',
  notAvailable: 'Not available',
};

export const sseEventsConfiguration = {
  orderEvent: true,
  assistanceEvent: true,
  timeOutMilis: 300000,
};

const { transactionTypeText } = resources.cashCard.popup.guestCashCardTransactionDetails;
export const cashCardTransactionTypes = {
  [transactionTypes.add]: { text: transactionTypeText.add },
  [transactionTypes.refund]: { text: transactionTypeText.refund },
  [transactionTypes.reward]: { text: transactionTypeText.reward },
  [transactionTypes.payment]: { text: transactionTypeText.payment },
  [transactionTypes.expired]: { text: transactionTypeText.expired },
};

export const additonalServiceChargesConfig = [
  { code: 'SC', title: resources.setting.additionalServiceCharges.serviceChargeTitle },
  { code: 'PC', title: resources.setting.additionalServiceCharges.packingChargeTitle },
  { code: 'AC', title: resources.setting.additionalServiceCharges.additionalChargesTitle },
];

export const defaultCountryCode = '+91';

export const cashCardTransactionStatus = {
  success: 'SUCCESS',
  failed: 'FAILED',
  pending: 'PENDING',
};

export const cashCardTransactionCat = ['A', 'C', 'D'];

export const issuedCashCardStatus = ['ACTIVE', 'inactive', 'BLOCKED'];

export const orderModesSettingsConfig = {
  orderModeTitleMaxLength: 20,
};

export const cancelOrderPopupConfig = {
  otherCancelReasonMaxLength: 200,
};

export const additionalRestaurantPropertiesConfig = {
  prepTimes: 'prepTimes',
  deliveryTimes: 'deliveryTimes',
};

export const preparationTimeListConfig = [5, 10, 15, 20, 25, 30];

export const deliveryTimeListConfig = [30, 40, 50, 60, 75, 90];

const customizedGroupResource = resources.menu.customization.customizedGroupDetails;
export const customizedGroupPopupConfig = {
  selectionTypes: {
    singleSelect: {
      ...customizedGroupResource.selectionTypes.singleSelect,
      code: 'SS',
    },
    multiSelect: {
      ...customizedGroupResource.selectionTypes.multiSelect,
      code: 'MS',
    },
  },
  maxGroupTitleLength: 100,
  minGroupTitleLength: 1,
};

export const customizedItemPopupConfig = {
  maxItemTitleLength: 50,
  minItemTitleLength: 1,
  maxItemDescriptionLength: 250,
};

export const customizationToastMessageTime = 3000;

export const restaurantPremiumFeaturesKeys = {
  pwa: 'PWA',
  upsell: 'UPSELL',
  cashCard: 'CASHCARD',
};

export const selectDeliveryLocationPopupConfig = {
  defaultZoomLevel: 11,
  defaultDeliveryRange: 10,
  maxDeliveryRange: 99,
  maxSliderValue: 20,
  minDeliverRange: 1,
  cicleZoom: 14.4,
  formFieldName: {
    deliveryArea: 'deliveryArea',
    deliveryRange: 'deliveryRange',
  },
  deliveryAreas: {
    acrossCity: 'CIT',
    googleMapCircle: 'GMC',
  },
  digitAfterDecimal: 2,
  maxDistanceBetweenRestaurantAddressAndSelectedAddress: 200,
};

export const subscriptionPlanBillingCycleTypes = {
  yearly: {
    code: 'YR',
    title: 'Yearly',
    altText: 'annually',
    durationInMonths: 12,
  },
  halfYearly: {
    code: 'HY',
    title: 'Half-Yearly',
    altText: 'half-yearly',
    durationInMonths: 6,
  },
  quarterly: {
    code: 'QY',
    title: 'Quarterly',
    altText: 'quarterly',
    durationInMonths: 3,
  },
  monthly: {
    code: 'MO',
    title: 'Monthly',
    altText: 'monthly',
    durationInMonths: 1,
  },
};

export const saasPlansConfig = {
  free: {
    code: 'free',
    background: colorCodes.freePlanBackgroundColor,
    foreground: colorCodes.primaryTextColor,
    // sequence: 1, // TODO: Identify whether this property would be needed in future, now that the saas plans' order is dictated by the subscription-feature JSON data
  },
  basic: {
    code: 'basic',
    background: colorCodes.basicPlanBackgroundColor,
    foreground: colorCodes.primaryTextColor,
    // sequence: 2, // TODO: Identify whether this property would be needed in future, now that the saas plans' order is dictated by the subscription-feature JSON data
  },
  plus: {
    code: 'plus',
    background: colorCodes.plusPlanBackgroundGradient,
    // sequence: 3,  // TODO: Identify whether this property would be needed in future, now that the saas plans' order is dictated by the subscription-feature JSON data
  },
  transaction: {
    code: 'transaction',
  },
};

export const subscriptionModuleEnabled = JSON.parse(ENABLE_SUBSCRIPTION_MODULE) || false;

export const subscriptionTrialPreExpiryReminderDays = 7;

export const subscriptionPlanPreExpiryReminderDays = 7;

export const subscriptionPlanTrialPostExpirationOverlayShowCount = 5;

export const subscriptionPlanPostExpirationOverlayShowCount = 5;

export const settingsConfig = {
  appIdNotFound: 'NOT_FOUND',
};

export const subscriptionFeatureCode = {
  offer: 'offer',
  offer_directDiscount: 'offer.typedd',
  offer_itemOffer: 'offer.typeio',
  offer_applicableMenu: 'offer.apmenu',
  offer_applicableMode: 'offer.apmode',
  offer_applicableGuest: 'offer.apgst',
  offer_applicableGuestRule: 'offer.gstrul',
  menu: 'menu',
  menu_recommendedMenu: 'menu.recom',
  menu_orderModeFilter: 'menu.modefl',
  menu_timeAvailability: 'menu.timeav',
  order: 'order',
  order_exportOrder: 'order.exp',
  order_printKot: 'order.prnkot',
  guest: 'guest',
  guest_contact: 'guest.cntct',
  guest_exportGuestList: 'guest.exp',
  notification: 'notification',
  restuarantTiming: 'restime',
  restuarantTiming_orderMode: 'restime.mode',
  digitalWaiterService: 'dws',
  delivery: 'delivery',
  delivery_map: 'delivery.map',
  delivery_hyperLocal: 'delivery.hlocal',
  additionalCharges: 'addchrg',
  additionalCharges_priceRange: 'addchrg.pr',
  additionalCharges_distanceBased: 'addchrg.dr',
  digitalStore: 'digistore',
  digitalStore_PWA: 'digistore.pwa',
  digitalStore_widget: 'digistore.widget',
  account: 'account',
  upsell: 'upsell',
  cashCard: 'cashcard',
  payment: 'payment',
  payment_Online: 'payment.online',
  payment_Offline: 'payment.offline',
};

export const firstWeekDay = 'Monday';

export const fudrCDNBasePath = FUDR_CDN_BASE_PATH || '';

export const marketableSaaSFeaturesJSONLink = `${fudrCDNBasePath}/assets/json/subscription-feature.json`;

export const saasPlansPopupPostCloseActions = {
  goBackInHistory: 'GO_BACK_IN_HISTORY',
  goBackToPreviousState: 'GO_BACK_TO_PREVIOUS_STATE',
};

export const bookTrainingLink = BOOK_TRAINING_LINK;

export const trainingVideosLink = TRAINING_VIDEOS_LINK;

export const subscriptionRequestRaiseLimitDays =
  JSON.parse(SUBSCRIPTION_REQUEST_RAISE_LIMIT_DAYS) ?? 1;

export const orderUpdateTypes = {
  customDiscount: 'CD',
  removeAdditionalCharge: 'RAC',
  updateItems: 'UOI',
};

export const additionalDiscountCodeConfig = {
  code: ADDITIONAL_DISCOUNT_CODE || '',
  stub: 'EXTRA DISCOUNT',
};

export const onboardingChecklistCode = {
  menu: 'MENU',
  bank: 'BANK',
  gst: 'GST',
  fssai: 'FSSAI',
  qr: 'QR',
};

const dateFiltersType = resources.guest.guestFiltersPopup.dateFilterlabel;

export const guestListDateFilters = {
  default: { code: 'DF', title: dateFiltersType.anyDate },
  today: { code: 'TD', title: dateFiltersType.today },
  thisWeek: { code: 'TW', title: dateFiltersType.thisWeek },
  thisMonth: { code: 'TM', title: dateFiltersType.thisMonth },
};

export const integrationTypes = {
  pos: 'POS',
};

export const posSyncEnabilityStatusCodes = { active: 'ACTIVE', inactive: 'INACTIVE' };

export const integrationEntityType = {
  table: 'TABLE',
  menuItem: 'MENU_ITEM',
  addon: 'ADDON', // Menu Customizations
};

const posIntegrationsResources = resources.integrations.pos;

export const posIntegrationTabs = {
  MIM: {
    label: posIntegrationsResources.tabLabel.menuItemMapping,
    value: integrationEntityType.menuItem,
  },
  TM: { label: posIntegrationsResources.tabLabel.tableMapping, value: integrationEntityType.table },
  // AOM: { label: posIntegrationsResources.tabLabel.addOnMapping, value: integrationEntityType.addon }, // renders tab when commented out
};

export const posSyncStatuses = {
  pending: 'PENDING',
  success: 'SUCCESS',
  failed: 'FAILED',
  fetching: 'FETCHING',
};

export const posSyncErrorCodes = {
  missingMenuItemMapping: 'MENU_ITEM_MAPPING_MISSING',
  internalSystemError: 'INTERNAL_SYSTEM_ERROR',
  externalSystemError: 'EXTERNAL_SYSTEM_ERROR',
  missingTableMapping: 'TABLE_MAPPING_MISSING',
};

export const bulkPOSSyncStatusConfig = {
  report: {
    page: 1,
    pageSize: 20,
    sort: 'creationTime',
  },
  filterTypes: {
    status: 'status',
    addedDate: 'addedDate',
  },
};

export const maxPOSBulkSyncLogsReportDays = 7;

export const bulkPageSize = 1000;

export const posVendors = {
  slickPos: 'SLICK_POS',
  petPooja: 'PET_POOJA'
};